import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { IRecording } from '../../appointments/recording/RecordingState';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { JournalIcon } from '../../theme/Icons';
import { AIDetailedSummary } from '../generic-notes/AIDetailedSummary';
import { INote } from '../generic-notes/INote';

export const DetailedSummary: FC<{ note: ICaremapNoteResponse | INote; }> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;
    const recordingHasDetailedSummary = Object.keys(recording?.summary?.detailedSummary || {}).some(k => Boolean((recording.summary?.detailedSummary as any)?.[k]?.length));

    return recordingHasDetailedSummary && recording.summary && (
        <ViewNoteSection title="Detailed Summary" Icon={JournalIcon} showAIIcon>
            <AIDetailedSummary recording={recording} />
        </ViewNoteSection>
    );
};
